import React from 'react';
interface BrandMarkProps {
  size?: number;
  className?: string;
}
/**
 * Growthly mark — a simple line globe.
 * Monochrome, 1px strokes, no fills: reads cleanly at 16px and at 48px.
 */
export function BrandMark({
  size = 18,
  className = ''
}: BrandMarkProps) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" className={className} aria-hidden="true" focusable="false" data-id="element-26" data-mp="ok94fy6urbmx">
      <circle cx="12" cy="12" r="9" data-id="element-27" data-mp="1h9ezlt76sdqv" />
      <path d="M3 12h18" data-id="element-28" data-mp="1ci6peuy18ocn" />
      <path d="M4.8 7.2h14.4" data-id="element-29" data-mp="1chonbhoovfwt" />
      <path d="M4.8 16.8h14.4" data-id="element-30" data-mp="1cglu333w91dq" />
      <path d="M12 3c2.4 2.6 3.6 5.6 3.6 9s-1.2 6.4-3.6 9c-2.4-2.6-3.6-5.6-3.6-9S9.6 5.6 12 3Z" data-id="element-31" data-mp="1cftznvm199p1" />
    </svg>;
}